import {isUndefined, isNil, isFunction} from '@malt/common';
import {store} from './store';

export function storeObj(obj, id, callback) {
    if (isUndefined(obj.id) && !isNil(id)) {
        obj.id = id;
    } else if (isUndefined(obj.id)) {
        try {
            Hop.logError(new Error('Object is missing an id: ' + JSON.stringify(obj)));
        } catch (e) {
            Hop.logError(new Error('Object is missing an id.'));
        }
    }

    if (!store.contains(obj.id)) {
        store.store(obj);
    } else {
        try {
            Hop.logError(new Error('An object is already defined with ID ' + obj.id + ': ' + JSON.stringify(obj)));
        } catch (e) {
            Hop.logError(new Error('An object is already defined with ID ' + obj.id));
        }
    }

    if (callback && isFunction(callback)) {
        callback();
    }

    return obj;
}
